import { TVacancySalaryInfo } from "@shared/cms";
import { formatCurrency } from "@shared/utils";
import { cn } from "@ubud-ui/react-ui-kit";

type VacancySalaryInfoProps = {
  currency?: string;
  min: number;
  max: number;
  show: boolean;
  meta: TVacancySalaryInfo;
  className?: string;
};
export function VacancySalaryInfo({ currency = "IDR", min, max, show, meta, className }: VacancySalaryInfoProps) {
  const getSalary = () => {
    if (!min && !max) {
      return meta.hideLabel;
    }

    if (min === max) {
      return formatCurrency(min, currency, "standard");
    }

    return `${formatCurrency(min, currency, "compact")}-${formatCurrency(max, currency, "compact")}`;
  };

  return (
    <>
      <div className={cn("text-lg sm:text-xl", className)}>{show ? getSalary() : meta.hideLabel}</div>
    </>
  );
}
